import { Signal, inject } from '@angular/core';

import { injectQuery } from '@tanstack/angular-query-experimental';

import { firstValueFrom } from 'rxjs';

import { UseCaseApiService } from '../services/use-case-api.service';

/**
 * Angular Query hooks for the Create Use Case wizard's two GET reads (§9, §12.2).
 * Preview and provision are NOT query hooks and NOT injectMutation - they are
 * direct API-service calls from the wizard, followed by explicit invalidation.
 */

/** Templates gallery. Company template set is effectively static per session. */
export function injectUseCaseTemplatesQuery() {
  const api = inject(UseCaseApiService);

  return injectQuery(() => ({
    queryKey: ['use_case', 'templates'],
    queryFn: () => firstValueFrom(api.getTemplates()),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 3,
  }));
}

/**
 * Input schema for the selected template. Disabled until a template is chosen;
 * re-keyed by templateId so selecting a different template refetches.
 */
export function injectUseCaseTemplateSchemaQuery(templateId: Signal<string>) {
  const api = inject(UseCaseApiService);

  return injectQuery(() => ({
    queryKey: ['use_case', 'template_schema', templateId()],
    queryFn: () => firstValueFrom(api.getTemplateSchema(templateId())),
    enabled: !!templateId(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 3,
  }));
}
